import React from "react";
import { ButtonDelete } from "../delegation_roles/components/ShowEmployeeDelegated/ShowEmployeeDelegated";
import {
    CloseIcon,
    Dialog,
    ExclamationTriangleIcon,
    Flex,
    Text,
} from "@fluentui/react-northstar";
import styled from "styled-components";

const DialogDeleteDocument = ({
    isDeleting = false,
    handleConfirmDeleteDocument = () => null,
}) => {
    const [open, setOpen] = React.useState(false);
    return (
        <Dialog
            open={open}
            headerAction={{
                icon: <CloseIcon outline />,
                iconOnly: true,
                title: "Supprimer",
                onClick: () => setOpen(false),
            }}
            cancelButton={{
                content: "Annuler",
                flat: true,
            }}
            onConfirm={handleConfirmDeleteDocument}
            confirmButton={{
                content: "Supprimer",
                loading: isDeleting,
                styles: {
                    backgroundColor: "var(--color-danger)",
                    color: "white",
                },
                flat: true,
            }}
            header={
                <Flex gap="gap.small" vAlign="center">
                    <ExclamationTriangleIcon outline />
                    <Text
                        content={
                            "Êtes-vous sûr.e de vouloir supprimer le ou les élément(s) ?"
                        }
                    />
                </Flex>
            }
            content={
                <TextDescr content="La sélection sera définitivement supprimée et la suppression ne pourra pas être annulée." />
            }
            onCancel={() => setOpen(false)}
            trigger={
                <ButtonDelete
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setOpen(true);
                    }}
                    content="Supprimer"
                    flat
                    text
                />
            }
            styles={{
                width: "764px",
            }}
        />
    );
};

export default DialogDeleteDocument;

const TextDescr = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-1424242,
        #424242
    );

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`;
